var map = {
	"./ASSCHER.png": "384a",
	"./CUSHION.png": "94e7",
	"./EMERALD.png": "4d52",
	"./HEART.png": "6563",
	"./MARQUISE.png": "adb9",
	"./OLD MINER CUT.png": "1076",
	"./OVAL.png": "17c3",
	"./PEAR.png": "292a",
	"./PRINCESS.png": "1352",
	"./RADIANT.png": "cbfb",
	"./ROUND.png": "9dde",
	"./SHIELD.png": "80e6",
	"./TRIANGULAR.png": "a8c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9feb";